export const testNotification = {
    type: 'test',
    name: 'Test notification',
    description: 'Internal test notification for verifying notification delivery.',
    text() {
        return `Test notification, please ignore`;
    },
    title() {
        return 'Test notification';
    },
    link() {
        return `/`;
    },
};
//# sourceMappingURL=test.js.map